<template>
  <b-card
    no-body
    class="card-payment"
  >
    <b-card-body>
      <b-tabs
        content-class="pt-1"
        fill
      >
        <b-tab
          active
          :title="$t('DEBTIA_COURT_FEE_TEXT')"
        >
          <court-fee />
        </b-tab>
        <b-tab
          :title="$t('DEBTIA_TAX_RETURN')"
        >
          <tax-return />
        </b-tab>
        <b-tab
          :title="$t('DEBTIA_STANDARD_PAYMENTS_ON_CASES')"
        >
          <standard-payments />
        </b-tab>
        <b-tab
          :title="$t('DEBTIA_UNDEFINED_PAYMENTS')"
        >
          <undefined-payments />
        </b-tab>
        <b-tab
          :title="$t('DEBTIA_INVOICE')"
        >
          <invoice />
        </b-tab>
      </b-tabs>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BTabs, BTab, BCard, BCardBody,
} from 'bootstrap-vue'
import CourtFee from './Tabs/CourFee.vue'
import StandardPayments from './Tabs/StandardPayments.vue'
import TaxReturn from './Tabs/TaxReturn.vue'
import UndefinedPayments from './Tabs/UndefinedPayments.vue'
import Invoice from './Tabs/Invoice.vue'

export default {
  components: {
    BTabs,
    BTab,
    BCard,
    BCardBody,
    StandardPayments,
    CourtFee,
    TaxReturn,
    UndefinedPayments,
    Invoice,
  },
  data() {
    return {
      // codeFill,
    }
  },
  created() {
  },
  methods: {
  },
}
</script>

  <style lang="scss">
  </style>
